import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useAlbumDetail, useAlbumDetailBySlug } from './hooks/useAlbumDetail';
import { useRelatedAlbums } from './hooks/useRelatedAlbums';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import PageLayout from '../../components/layout/PageLayout';
import AppUiScope from '../../app-ui/AppUiScope';
import AppContentSection from '../../app-ui/AppContentSection';
import BrowseLink from '../../features/browse/BrowseLink';
import AlbumLoadState from './components/album/AlbumLoadState';
import { SecondaryAlbumCard } from './components/album/AlbumSecondaryContent';
import { albumIdentity, relatedParentPath } from './components/album/albumSecondaryModel';
import useTrackPageView from '../../hooks/useTrackPageView';
import { PAGE_TYPE, CONTENT_TYPE } from '../../constants/gaEnums';
// Retain inbound legacy web URLs; iOS58 does not expose a related-albums More action.
export default function RelatedAlbumsViewAll() {
  const params = useParams(),
    location = useLocation(),
    { locale } = useWebLocale(),
    en = locale === 'en';
  const slug = useAlbumDetailBySlug(params.albumSlug),
    direct = useAlbumDetail(params.albumSource, params.sourceId),
    query = params.albumSlug ? slug : direct,
    album = query.data;
  const related = useRelatedAlbums(album?.sourceId, album?.albumSource);
  const parent = relatedParentPath(location.pathname, location.search);
  useTrackPageView(
    {
      pageType: PAGE_TYPE.REVIEWS_POST,
      contentType: CONTENT_TYPE.ALBUM,
      contentId: album?.sourceId,
      contentName: album?.title,
      reviewsSection: 'recommended_album',
    },
    { ready: !!album },
  );
  return (
    <PageLayout>
      <AppUiScope className="pp-secondary-legacy">
        <BrowseLink to={parent}>
          {en ? 'Back to album' : '앨범으로 돌아가기'}
          {album?.title ? ` · ${album.title}` : ''}
        </BrowseLink>
        <AlbumLoadState
          loading={query.isLoading}
          error={query.isError}
          album={album}
          onRetry={query.retry || query.refetch}
        >
          <AppContentSection title={en ? 'Related Albums' : '관련 앨범'}>
            {related.isError ? (
              <div className="pp-secondary-state" role="alert">
                <span>{en ? 'Could not load this section.' : '이 영역을 불러오지 못했어요.'}</span>
                <button onClick={() => related.refetch()}>{en ? 'Try Again' : '다시 시도'}</button>
              </div>
            ) : related.isLoading ? (
              <p role="status">{en ? 'Loading…' : '불러오는 중…'}</p>
            ) : related.data?.length ? (
              <div className="pp-secondary-full-grid">
                {related.data.map((item) => (
                  <SecondaryAlbumCard key={albumIdentity(item)} album={item} />
                ))}
              </div>
            ) : (
              <p>{en ? 'No related albums.' : '관련 앨범이 없습니다.'}</p>
            )}
          </AppContentSection>
        </AlbumLoadState>
      </AppUiScope>
    </PageLayout>
  );
}
